import React from 'react';

const ColumnTitle = (props) => {
    return (
        <div>
        <label style={{fontWeight: 'normal'}} className={"clickable custom" + (props.columnaActivaOrdenamiento == props.columnIndex ? " seccionGrilla__registroCabecera--columnaActiva" : "")}>
          <span onClick={() => props.orderColumn(props.columnIndex)}>
            {props.title}
            {props.columnaActivaOrdenamiento != undefined ?
              (props.order == false && props.icon == false ?
                <i className="seccionGrilla__registroCabeceraTrianguloUp"></i>
                : (props.order == true && props.icon == false) ?
                <i className="seccionGrilla__registroCabeceraTrianguloUp seccionGrilla__registroCabeceraTrianguloUpActivo seccionGrilla__registroCabeceraTrianguloUp--descendente"></i>
                : <i className={"seccionGrilla__registroCabeceraTrianguloUp " + (props.order == true ? "seccionGrilla__registroCabeceraTrianguloUpActivo" : "")}></i>)
              : <i className="seccionGrilla__registroCabeceraTrianguloUp"></i>}
          </span>
        </label>
      </div>
      
    );
}

export default ColumnTitle;